/**
 * Moteur qui a qualifié automatiquement une transaction bancaire (`qualificationSource.code`).
 * Une transaction qualifiée par une règle, saisie ou justifiée par une personne n'en a pas.
 */
export enum BankAccountLineQualificationSourceEnum {
    Ai = 'ai',
    Memory = 'memory',
}
